<template>
	<div class="Echartbox">
		<div id="visitEchart" ></div>
		
	</div>
</template>

<script>
	import {
		randomArr
	} from "../js/billet.js"
	export default {
		name: "visitEchart",
		props: {
			dataobj: {
				type: Object,
				default: ()=>{
					return {}
				},
			},
			
		},
		
		
		data() {
			return {
				myChart2: null,
				option: {
					color: ['rgba(36, 198, 255, 1)', 'rgba(43, 117, 235, 1)', 'rgba(88, 226, 204, 1)'],
					tooltip: {
						trigger: 'axis',
						// 提示框浮层的文本样式。
						backgroundColor: 'rgb(255, 255, 255)',
						extraCssText: 'box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;',
						textStyle: {
							color: '#363636'
						},
						axisPointer: {
							type: 'shadow'
						}
					},
					// legend: {},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '10%',
						containLabel: true
					},
					xAxis: [
						{
							type: 'category',
							axisTick: {
								lineStyle: {
									color: 'rgb(222,222,222)'
								},
								alignWithLabel: true
							},
						},
					],
					yAxis: [
						{
							type: 'value',
							axisLine: {
								show: false,
							},
							axisTick: {
								show: false,
							},
							axisLabel: {
							    formatter: '{value}次'
							},
						},
						
					],
					series: [
						{
							name: '名片',
							type: 'bar',
							
							// stack: 'overlap',
							// emphasis: {
							// 	focus: 'series'
							// },
							
							barWidth: '10%',
							data: []
						},
						{
							name: '文章',
							type: 'bar',
							barWidth: '10%',
							// barGap:'-100%',//移动第二个柱子的位置实现重叠
							// z:'-1',//改变这根柱子的层级使这根柱子在下面
							// stack: 'overlap',
							
							// emphasis: {
							// 	focus: 'series'
							// },
							data: []
						},
						{
							name: '产品',
							type: 'bar',
							barWidth: '10%',
							// stack: 'overlap',
							// barGap:'-100%',//移动第二个柱子的位置实现重叠
							// z:'-2',//改变这根柱子的层级使这根柱子在下面
							// emphasis: {
							// 	focus: 'series'
							// },
							data: []
						},


					]
				},
			}
		},

		watch: {
			dataobj(){
				this.fn_SetDatas()
			},
		},
		methods: {
			fn_SetDatas(){
				if(this.dataobj) {
					let len = this.option.series.length
					for(let i = 0; i < len;i++) {
						if(i == 0) { // 名片
							this.option.series[i].data = this.dataobj.card ? this.dataobj.card : [];
						}
						else if(i == 1) {  // 文章
							this.option.series[i].data = this.dataobj.article ? this.dataobj.article : [];
						}
						else if(i == 2) {  // 产品
							this.option.series[i].data = this.dataobj.goods ? this.dataobj.goods : [];
						}
					}
					this.getxAxisStr()
					
				}
			},
			getxAxisStr() {
				let arr = []
				for (let i = 1; i < 25; i++) {
					let timeStr = ''
					if (i < 10) {
						timeStr = `0${i}: 00`
					} else {
						timeStr = `${i}: 00`
					}
					arr.push(timeStr)
				}
				this.option.xAxis[0].data = arr
				this.drawLine()
			},

			drawLine() {
			
				// 基于准备好的dom，初始化echarts实例
				let myChart2 = this.$echarts.init(document.getElementById('visitEchart'))
				// 绘制图表
				myChart2.setOption(this.option);
				this.myChart2 = myChart2;
				
			},




		},
	}
</script>

<style scoped lang="scss">
	.Echartbox {
		width: 100%;
		background-color: #fff;
		margin-bottom: 10px;
		position: absolute;
		height: 100%;
		#visitEchart{
			width: 100%;
			height: 100%;
		}
	}
</style>
